<template>
  <transaction-list
    :product="product"
    :transactionService = transactionService
  ></transaction-list>
</template>
<script>
  import TransactionList from '@/components/Common/Transaction/TransactionList'
  import transactionService from '@/services/slotting/transaction'

  export default {
    components: {
      TransactionList
    },
    props: {
      product: Object,
      show: Boolean
    },
    data () {
      return {
        transactionService: transactionService,
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Slotting/Products/Transaction.vue